import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialCentsScoreCard = ({ score, tier, nextTierScore, tierProgress }) => {
  const getTierColor = (tierName) => {
    const colors = {
      Bronze: 'from-amber-600 to-amber-800',
      Silver: 'from-slate-400 to-slate-600',
      Gold: 'from-yellow-400 to-yellow-600',
      Platinum: 'from-teal-400 to-teal-600',
      Diamond: 'from-blue-400 to-blue-600'
    };
    return colors?.[tierName] || 'from-teal-500 to-blue-500';
  };

  const getTierIcon = (tierName) => {
    const icons = {
      Bronze: 'Award',
      Silver: 'Medal',
      Gold: 'Trophy',
      Platinum: 'Crown',
      Diamond: 'Gem'
    };
    return icons?.[tierName] || 'Award';
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-lg">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground mb-1">SocialCents Score</h2>
          <p className="text-sm text-muted-foreground">Your influence rating</p>
        </div>
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl bg-gradient-to-br ${getTierColor(tier)} flex items-center justify-center`}>
          <Icon name={getTierIcon(tier)} size={24} color="#FFFFFF" />
        </div>
      </div>

      <div className="mb-6">
        <div className="flex items-baseline gap-2 mb-2">
          <span className="text-4xl md:text-5xl font-bold text-foreground">{score}</span>
          <span className="text-lg md:text-xl text-muted-foreground">/ 1000</span>
        </div>
        <div className="flex items-center gap-2">
          <span className={`px-3 py-1 rounded-full text-xs md:text-sm font-medium bg-gradient-to-r ${getTierColor(tier)} text-white`}>
            {tier} Tier
          </span>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Progress to {tier === 'Diamond' ? 'Max' : 'next tier'}</span>
          <span className="text-foreground font-medium">{tierProgress}%</span>
        </div>
        <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className={`h-full bg-gradient-to-r ${getTierColor(tier)} transition-all duration-500 ease-out`}
            style={{ width: `${tierProgress}%` }}
          />
        </div>
        {tier !== 'Diamond' && (
          <p className="text-xs md:text-sm text-muted-foreground">
            {nextTierScore - score} points to reach next tier
          </p>
        )}
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="TrendingUp" size={16} color="var(--color-success)" />
          <span>Score updated daily based on engagement</span>
        </div>
      </div>
    </div>
  );
};

export default SocialCentsScoreCard;